import React from 'react';
import PropTypes from 'prop-types';

RoadMapItem.propTypes = {
    item: PropTypes.object,
};

function RoadMapItem(props) {
    const {item} = props;
    return (
        <div key={item.id} className={`rm-box ${item.positon}`}>
            <div className={`corner-box ${item.style}`}>
                <h6>{item.time}</h6>
                <ul>
                    {
                        item.list.map((li,idx) => (
                            <li key={idx}>{li.text}</li>
                        ))
                    }
                </ul>
            </div>
        </div>
    );
}

export default RoadMapItem;
